import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import bgImage from "../assets/cover.jpg";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
// import { SOCKET_SERVER_IP, SOCKET_PORT } from "./config";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "./config";

// const socket = io(`http://${SOCKET_SERVER_IP}:${SOCKET_PORT}`);
const socket = io(API_BASE, {
  transports: ["websocket"],
  secure: true,
});
export default function Power() {
  const [time, setTime] = useState(new Date());
  const [result, setResult] = useState(null);
  const [powerStatus, setPowerStatus] = useState("OFF");
  const navigate = useNavigate();

  // Update jam setiap detik
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Ambil status awal power dari backend
  useEffect(() => {
    fetch(`http://${API_BASE}/api/power/status?readerId=POWER1`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.status) {
          setPowerStatus(data.status);
          console.log("📡 Status awal dari server:", data.status);
        }
      })
      .catch((err) => console.error("Gagal ambil status awal:", err));
  }, []);

  // Listen event realtime dari backend
  useEffect(() => {
    socket.on("power-status", (data) => {
      console.log("⚡ Power status update:", data);
      if (data.readerId === "POWER1") setPowerStatus(data.status);
    });

    socket.on("rfid-scan", (data) => {
      console.log("RFID Scan Result:", data);

      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Access Denied",
          text: data.error,
          confirmButtonColor: "#d33",
        });
        return;
      }

      // Update status & tampilan
      setResult(data);
      setPowerStatus(data.action);

      Swal.fire({
        icon: data.granted ? "success" : "warning",
        title: data.granted ? "Akses Diterima" : "Akses Ditolak",
        html: `
          <p><b>${data.nama}</b></p>
          <p>${data.departemen || "-"} • ${data.lokasi}</p>
          <p>${data.action === "ON" ? "Menyalakan" : "Mematikan"} Power</p>
          <small>${data.waktu || ""}</small>
        `,
        timer: 2000,
        showConfirmButton: false,
      });
    });

    return () => {
      socket.off("power-status");
      socket.off("rfid-scan");
    };
  }, []);

  return (
    <div
      className="relative flex flex-col items-center justify-center min-h-screen"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/70"></div>
      <img
        src={logo}
        alt="SSD Logo"
        onClick={() => navigate("/")}
        className="h-12 absolute top-4 left-6 z-20 cursor-pointer"
      />

      <div className="relative z-10 text-center text-white p-6 w-full max-w-3xl">
        <h1 className="text-4xl font-bold mb-2">Safe Power System</h1>

        <div className="text-2xl font-semibold mb-6">
          {time.toLocaleTimeString()} <br />
          {time.toLocaleDateString("id-ID", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>

        {/* LED STATUS */}
        <div className="flex flex-col items-center mb-8">
          <div
            className={`w-24 h-24 rounded-full shadow-inner border-4 ${
              powerStatus === "ON"
                ? "bg-green-500 border-green-700 animate-pulse"
                : "bg-red-600 border-red-800"
            }`}
          ></div>
          <p className="mt-2 text-2xl font-bold tracking-wide">
            {powerStatus === "ON" ? "POWER ON" : "POWER OFF"}
          </p>
        </div>

        {/* DETAIL USER TERAKHIR */}
        {result && (
  <div className="mt-6 bg-white/95 text-black rounded-xl shadow-lg p-6">
    {result?.action && (
      <h2 className="text-2xl font-bold mb-4">
        Power {result.action.toUpperCase()}
      </h2>
    )}
    <p><strong>Nama:</strong> {result?.nama || "-"}</p>
    <p><strong>Departemen:</strong> {result?.departemen || "-"}</p>
    <p><strong>Lokasi:</strong> {result?.lokasi || "-"}</p>
    <p><strong>Waktu:</strong> {result?.waktu || "-"}</p>
    <p
      className={`mt-4 font-bold text-xl ${
        result?.granted ? "text-green-600" : "text-red-600"
      }`}
    >
      {result?.granted ? "Akses Diterima" : "Akses Ditolak"}
    </p>
  </div>
)}


        {!result && (
          <p className="text-lg italic text-gray-300 mt-4">
            Silakan Tap kartu RFID di reader untuk menyalakan / mematikan power robot.
          </p>
        )}
      </div>
    </div>
  );
}
